import { Waves } from 'lucide-react';

/** Ícone da Wake Comex (onda sobre o azul da marca). */
export function WakeLogoIcon() {
  return (
    <div
      style={{
        width: 34,
        height: 34,
        borderRadius: 9,
        background: '#2563eb',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Waves size={18} strokeWidth={2} color="#fff" />
    </div>
  );
}

/**
 * Logo da Wake Comex (ícone + marca). `tone` é o fundo onde ele aparece: `dark`
 * (marca em branco) ou `light` (marca no token de texto, acompanha o tema).
 */
export function WakeLogo({ tone = 'dark' }: { tone?: 'dark' | 'light' }) {
  return (
    <div role="img" aria-label="Wake Comex" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <WakeLogoIcon />
      <div style={{ lineHeight: 1, textAlign: 'left' }}>
        <div
          className={tone === 'dark' ? 'text-white' : 'text-body'}
          style={{ fontSize: 19, fontWeight: 700, letterSpacing: '-0.01em' }}
        >
          Wake
        </div>
        <div
          style={{
            fontSize: 9.5,
            fontWeight: 600,
            letterSpacing: '0.22em',
            color: '#2563eb',
            marginTop: 3,
          }}
        >
          C O M E X
        </div>
      </div>
    </div>
  );
}
